import { BRAND_ORDER_RECAP_UPDATE } from "constants/action-types";

export const updateOrderRecap = (payload: string[]) => ({
    payload,
    type: BRAND_ORDER_RECAP_UPDATE.START,
});
